module.exports = __webpack_public_path__ + "img/sidenav-active.e998bcc0.svg";